// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col col="12" justify-center>
        <v-card>
          <v-card-title class="headline">
            Usage
          </v-card-title>
          <v-card-text>
            <p>Total Users: {{ users }}</p>
            <p>Total Images: {{ images }}</p>
            <p>Total Storage: {{ storage }} GB</p>
            <template v-if="showPrice">
              <hr>
              <br>
              <p>Price / User / month: ${{ formatDollars(configuration.pricePerUser) }}</p>
              <p>Price / GB / month: ${{ formatDollars(configuration.pricePerGB) }}</p>
              <p>Base Price: ${{ formatDollars(configuration.priceBase) }}</p>
              <p>GB / user / month: {{ configuration.storagePerUser }}</p>
              <p>GB base: {{ configuration.storageBase }}</p>

              <hr >
              <br>
              <p class="title">Total Price: ${{ formatDollars(priceTotal) }}</p>
              <p>Users Price: ${{ formatDollars(priceUsers) }}</p>
              <p>Storage Alloted: {{ storageAlloted }} GB</p>
              <p>Storage Free: {{ storageFree }} GB</p>
              <p>Storage Overage: {{ storageOverage }} GB</p>
              <p>Storage Price: ${{ formatDollars(priceStorage) }}</p>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import { mapGetters } from 'vuex'
import {checkPermission} from 'vue-common/components/user'
import {PERMISSIONS} from 'vue-common/components/constants'

export default {
  data () {
    return {
      configuration: {},
      images: 0,
      storage: 0,
      users: 0
    }
  },

  created () {
    if (this.showPrice) {
      ApiRequests.getConfiguration().then(r => {
        this.configuration = r.data
      })
    }

    ApiRequests.getUsers().then(r => {
      this.users = r.data.length
    })

    ApiRequests.getImages({limit: 1}).then(r => {
      this.images = parseInt(r.headers['x-total-count'])
    })

    ApiRequests.getStorageUsage().then(r => {
      this.storage = this.bytesToGB(parseInt(r.data.sum))
    })
  },

  computed: {
    ...mapGetters([
      'accessRules'
    ]),

    priceStorage: function () {
      return this.storageOverage * this.configuration.pricePerGB
    },

    priceTotal: function () {
      return this.priceStorage + this.configuration.priceBase + this.priceUsers
    },

    priceUsers: function () {
      return this.configuration.pricePerUser * this.users
    },

    storageAlloted: function () {
      return this.users * this.configuration.storagePerUser + this.configuration.storageBase
    },

    storageFree: function () {
      return this.storageAlloted - this.storage
    },

    storageOverage: function () {
      var total = this.storage - this.storageAlloted
      if (total > 0) {
        return total
      }
      return 0
    },

    showPrice: function () {
      return checkPermission(this.accessRules, 'configuration', PERMISSIONS.DELETE)
    }
  },

  methods: {
    bytesToGB: function (v) {
      if (typeof v === 'number') {
        return (v / 1000000000).toFixed(3)
      }
      return (0).toFixed(3)
    },

    formatDollars: function (v) {
      if (typeof v === 'number') {
        return v.toFixed(2)
      }
      return (0).toFixed(2)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Usage.vue?5550e4f4